<template>
  <!-- BEGIN pos-content -->
  <div class="pos-content" data-scrollbar="true">
    <div
      class="ts-sticky ts-top-0 ts-z-50 ts-shadow-md sub-group"
      style="background: #f2f3f4;"
    >
      <div class="row">
        <div class="col-lg-7 col-md-6 col-sm-6 col-xs-12">
          <a-tabs
            v-if="subCategories.length > 0"
            :active-key="localActiveKey"
            :tab-position="mode"
            :style="{ background: '#f2f3f4' }"
            @prevClick="$emit('callback')"
            @nextClick="$emit('callback')"
            @change="handleTabChange"
            class="ts-sticky ts-top-0 ts-z-50 kh-font"
          >
            <a-tab-pane
              v-for="c in subCategories"
              :key="c.pro_group_id"
              class="kh-font"
            >
              <span slot="tab">
                <i :class="c.icon" class="fa-fw"></i>
                {{ locale == 'kh' ? c.pro_group_name_kh : c.pro_group_name_en }}
              </span>
            </a-tab-pane>
          </a-tabs>
          <a-tabs
            v-if="categories.length > 0"
            :active-key="localActiveKeyCategory"
            :tab-position="mode"
            :style="{ background: '#f2f3f4' }"
            @prevClick="$emit('callback')"
            @nextClick="$emit('callback')"
            @change="handleCategoryTabChange"
            class="ts-sticky ts-top-0 ts-z-50 kh-font"
          >
            <a-tab-pane
              v-for="c in categories"
              :key="c.category_id"
              class="kh-font"
            >
              <span slot="tab">
                <i :class="c.icon" class="fa-fw"></i>
                {{ locale == 'kh' ? c.category_name_kh : c.category_name_en }}
              </span>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12">
          <div class="search-box">
            <SearchBox
              :value="fetchOptions"
              @input="$emit('update-search-value', $event.search_value)"
              @onEnter="$emit('search-barcode')"
              class="search-component"
            />
            <div v-if="!fullscreen">
              <button
                @click="$emit('open-fullscreen')"
                v-tooltip="'Open Fullscreen'"
                class="nav-link"
              >
                <i class="fas fa-expand fa-2x"></i>
              </button>
            </div>
            <div v-if="fullscreen">
              <button
                @click="$emit('close-fullscreen')"
                v-tooltip="'Close Fullscreen'"
                class="nav-link"
              >
                <i class="fas fa-compress fa-2x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ts-loading-banner :loading="productFetching">
      <ProductGrid
        :products="products"
        :data-send="dataSend"
        :locale="locale"
        :product-category="productCategory"
        :sub-categories="subCategories"
        :categories="categories"
        @select-product="$emit('select-product', $event)"
        @add-product="$emit('add-product', $event)"
        @increase-quantity="$emit('increase-quantity', $event)"
        @decrease-quantity="$emit('decrease-quantity', $event)"
        @remove-product="$emit('remove-product', $event)"
      />
    </ts-loading-banner>
  </div>
  <!-- END pos-content -->
</template>

<script>
import SearchBox from './SearchBox.vue'
import ProductGrid from './ProductGrid.vue'

export default {
  name: 'PosContent',
  components: {
    SearchBox,
    ProductGrid
  },
  props: {
    subCategories: {
      type: Array,
      default: function() {
        return []
      }
    },
    categories: {
      type: Array,
      default: function() {
        return []
      }
    },
    activeKey: String,
    activeKeyCategory: String,
    mode: String,
    products: {
      type: Array,
      default: function() {
        return []
      }
    },
    dataSend: {
      type: Object,
      default: function() {
        return {}
      }
    },
    locale: String,
    fullscreen: Boolean,
    productFetching: Boolean,
    productCategory: {
      type: Array,
      default: function() {
        return []
      }
    },
    fetchOptions: {
      type: Object,
      default: () => ({ search_value: '' })
    }
  },
  data() {
    return {
      localActiveKey: this.activeKey,
      localActiveKeyCategory: this.activeKeyCategory
    }
  },
  watch: {
    // Update local values when props change
    activeKey(newVal) {
      this.localActiveKey = newVal
    },
    activeKeyCategory(newVal) {
      this.localActiveKeyCategory = newVal
    }
  },
  methods: {
    updateFetchOptions(newValue) {
      this.fetchOptions = newValue
      this.$emit('search-value-changed', newValue.search_value)
    },
    handleTabChange(activeKey) {
      this.localActiveKey = activeKey
      this.$emit('change-sub-category', activeKey)
    },
    handleCategoryTabChange(activeKey) {
      this.localActiveKeyCategory = activeKey
      this.$emit('change-main-category', activeKey)
    }
  },
  watch: {
    'fetchOptions.search_value': {
      handler(value) {
        this.$emit('search-value-changed', value)
      }
    }
  }
}
</script>

<style scoped>
.search-box {
  padding: 5px 0 5px 10px;
  background: #6c757d;
  color: #ffffff;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
}
/* @media (max-width: 1257.98px) {
  .pos-customer .pos-content .search-component {
    display: none;
  }
}
@media (max-width: 991px) {
  .pos-customer .pos-content .sub-group, .search-box {
    display: none;
  }
} */
</style>
